import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setPatientList } from 'src/store/modules/admin/activityLog'

import { PATIENT_LIST } from 'src/constants'
import admin from 'src/services/@core/API/routes/admin'

export const getPatientList = () => async (dispatch) => {
  const patientList = await admin.getPatientList()

  dispatch(setPatientList(patientList))
}

export const updatePatientList = (profile, list) => async (dispatch) => {
  const patientList = list.map((patient) =>
    patient.uuid === profile.uuid ? profile : patient
  )

  dispatch(setPatientList(patientList))
}

export const getFilteredPatientList = (query) => async () => {
  try {
    const patientList = await httpClient.request({
      method: 'get',
      url: {
        pathname: PATIENT_LIST,
        query: {
          ...query,
          excludeCaregivers: true
        }
      }
    })

    return patientList
  } catch (err) {
    catchError(err)

    return []
  }
}
